import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Menu,
  MenuItem,
  Select,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Page from "../../component/Page";
import { getBranchList } from "../setting/services/settingApi";
import { REPORT_CONFIG } from "./config";
import api from "../../api/api";
import { saveAs } from "file-saver";
export default function ReportPlanDistribution() {
  const { profile } = useSelector((state) => state.profile);
  const [y, setY] = useState(new Date().getFullYear() + 543);
  const [reports, setReports] = useState([]);
  const [branchs, setBranchs] = useState([]);
  const [BranchNo, setBranchsNo] = useState("");
  const [loadingDownload, setloadingDownload] = useState(false);
  const [loading, setloading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [version, setVersion] = useState('1');

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  async function getReportPlanDistribution(body, mode, format) {
    const url = `${REPORT_CONFIG.requests.getReportDistribution.url}/${mode}`;
    let _params = "";
    let _y = "";
    let _v = "";
    let _branchNo = "";
    let _format = "";
    if (body.y) {
      _y = "y=" + body.y;
    }
    if (body.v) {
        _v = "&v=" + body.v;
      }
    if (body.branchNo) {
      _branchNo = "&branchNo=" + (body.branchNo !== "-" ? body.branchNo : "");
    }

    if (format) {
      _format = "&format=" + format;
    }
    _params = "?" + _y + _branchNo + _v + _format;
    if (mode === "file") {
      setloadingDownload(true);
      const res = await api.get(url + _params, { responseType: "arraybuffer" });
      const data = res.data;
      if (format) {
        const blob = new Blob([data], { type: "application/pdf" });
        saveAs(blob, "แผนส่งเสริมการกระจายเมล็ดพันธุ์ข้าว (กมข-20403)");
      } else {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "แผนส่งเสริมการกระจายเมล็ดพันธุ์ข้าว (กมข-20403)");
      }
      setloadingDownload(false);
    } else {
      setloading(true);
      const res = await api.get(url + _params);
      const data = res.data.result;
      setReports(data);
      setloading(false);
    }
  }
  useEffect(() => {
    getBranchList(null, setBranchs);
  }, []);
  useEffect(() => {
    if (profile?.BranchNo?.BranchNo) {
      setBranchsNo(profile?.BranchNo?.BranchNo);
      LoadReport();
    }
  }, [profile]);
  async function LoadReport() {
    const body = {
      y: y,
      v: version,
      branchNo: BranchNo || profile?.BranchNo?.BranchNo,
    };
    getReportPlanDistribution(body, "data");
  }
  return (
    <div style={{ padding: "10px 30px" }}>
      <Page>
        <div class="container-fluid p-0">
          <form>
            <div class="row  no-gutters">
              <div class="col-12 col-lg-2">
                <div class="row no-gutters">
                  <div class="col-12 header-row border-1 ">ตัวกรอง</div>
                </div>
                <div class="row no-gutters p-2 border-1">
                  <div class="col-12">
                    <label class="labelInput">ปีงบประมาณ</label>

                    <Box className="backgroundField">
                      <TextField
                        value={y}
                        onChange={(e) => setY(e.target.value)}
                        variant="standard"
                        fullWidth
                        InputProps={{
                          disableUnderline: true,
                        }}
                      />
                    </Box>
                  </div>

                  <div class="col-12">
                    <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "10px" }}
                    >
                      <FormControl variant="standard" fullWidth>
                        <Select
                          value={BranchNo || "-"}
                          onChange={(e) => setBranchsNo(e.target.value)}
                          disableUnderline
                        >
                          <MenuItem value="-">-</MenuItem>
                          {branchs?.map((x) => (
                            <MenuItem value={x?.BranchNo}>
                              {x?.BranchName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </div>
                  <div class="col-12">
                    <RadioGroup
                      value={version || ""}
                      onChange={(e) => setVersion(e.target.value)}
                      row
                    >
                      <FormControlLabel
                        value="1"
                        control={<Radio />}
                        label="ครั้งที่ 1 (ต.ค. - ก.ย.)"
                      />
                      <FormControlLabel
                        value="2"
                        control={<Radio />}
                        label="ครั้งที่ 2 (เม.ย. - ก.ย.)"
                      />
                    </RadioGroup>
                  </div>
                  <div class="col-12">
                    <Button
                      onClick={LoadReport}
                      disabled={loading ? true : false}
                      variant="contained"
                      className="ButtomSearch"
                    >
                      {loading ? (
                        <CircularProgress size={"18px"} color="inherit" />
                      ) : (
                        "ค้นหา"
                      )}{" "}
                    </Button>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-10">
                <div class="row no-gutters">
                  <div class="col-12 d-flex justify-content-between header-row border-1 ">
                    <div>แผนส่งเสริมการกระจายเมล็ดพันธุ์ข้าว (กมข-20403)</div>
                    <Button
                      variant="contained"
                      id="basic-button"
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      disabled={loadingDownload ? true : false}
                      onClick={handleClick}
                    >
                      {loadingDownload ? (
                        <CircularProgress size={"18px"} color="inherit" />
                      ) : (
                        "ดาวน์โหลด"
                      )}
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                      PaperProps={{
                        style: {
                          width: 100,
                        },
                      }}
                    >
                      <MenuItem
                        onClick={() => {
                          const body = {
                            y: y,
                            branchNo: BranchNo || undefined,
                            v: version,
                          };
                          // setFormat('')
                          getReportPlanDistribution(body, "file");

                          handleClose();
                        }}
                      >
                        Excel
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          const body = {
                            y: y,
                            branchNo: BranchNo || undefined,
                            v: version,
                          };
                          // setFormat('pdf')
                          getReportPlanDistribution(body, "file", "pdf");

                          handleClose();
                        }}
                      >
                        Pdf
                      </MenuItem>
                    </Menu>
                  </div>
                </div>
                <div class="row no-gutters border-1 pt-3">
                  <div class="report col-12">
                    <div class="text-end" style={{ color: "red" }}>
                      ( หน่วย : ตัน )
                    </div>
                    <div class="table-responsive-sm" style={{ height: "auto" }}>
                      <table class="table table-bordered table-sm table-hover">
                        <thead class="sticky-thead">
                          <tr>
                            <th scope="col" rowspan="3">
                              ที่
                            </th>
                            <th scope="col" rowspan="3">
                              ช่วงเวลา (เดือน)
                            </th>
                            <th scope="col" colspan="7">
                              สัดส่วนช่องทางการจำหน่าย
                            </th>
                            <th scope="col" rowspan="3">
                              รวม
                            </th>
                            <th scope="col" rowspan="3">
                              สถานที่ที่จะส่งเสริม(ระบุจังหวัด)
                            </th>
                          </tr>
                          <tr>
                            <th scope="col" rowspan="2">
                              โครงการ/ส่วนราชการ
                            </th>
                            <th scope="col" colspan="4">
                              ตัวแทนจำหน่าย
                            </th>
                            <th scope="col" colspan="2">
                              เกษตรกร/กลุ่มเกษตรกร/ร้านค้า
                            </th>
                          </tr>
                          <tr>
                            <th scope="col">ราคาเต็ม</th>
                            <th scope="col">ลด 5 %</th>
                            <th scope="col">ลด 7 %</th>
                            <th scope="col">ลด 8 %</th>
                            <th scope="col">ราคาเต็ม</th>
                            <th scope="col">ส่วนลด</th>
                          </tr>
                        </thead>
                        <tbody>
                          {reports?.map((report, i) => (
                            <tr class="cp">
                              <td class="text-center">{i + 1}</td>
                              <td class="text-center">{report?.MonthName}</td>
                              <td class="text-center">
                                {parseFloat(report?.Campaign)
                                  .toFixed(3)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                              </td>
                              <td class="text-center">
                                {parseFloat(report?.AgentDiscount0)
                                  .toFixed(3)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                              </td>
                              <td class="text-center">
                                {parseFloat(report?.AgentDiscount5)
                                  .toFixed(3)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                              </td>
                              <td class="text-center">
                                {parseFloat(report?.AgentDiscount7)
                                  .toFixed(3)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                              </td>
                              <td class="text-center">
                                {parseFloat(report?.AgentDiscount8)
                                  .toFixed(3)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                              </td>
                              <td class="text-center">
                                {parseFloat(report?.OtherDiscount0)
                                  .toFixed(3)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                              </td>
                              <td class="text-center">
                                {parseFloat(report?.OtherDiscount5)
                                  .toFixed(3)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                              </td>
                              <td class="text-center">
                                {parseFloat(report?.Total)
                                  .toFixed(3)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                              </td>
                              <td class="text-center">
                                {report?.ProvinceName}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                {reports.length === 0 && (
                  <div class="row">
                    <div class="col-12">
                      <div class="not-found">ไม่พบข้อมูล</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </Page>
    </div>
  );
}
